/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ChevronsDownUp = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "m7 20 5-5 5 5" }],
    ["path", { d: "m7 4 5 5 5-5" }]
  ]
];

export { ChevronsDownUp as default };
//# sourceMappingURL=chevrons-down-up.js.map
